import useAnalytics from '@sdk/analytics/useAnalytics';
import { AnalyticsEvents } from '@sdk/analytics/types';
import getNowDate from '@sdk/utils/getNowDate';
import { SUBSCRIPTION_LEVELS } from '@sdk/account/constants';
import useModalState from '@sdk/components/ui/modal/useModalState';

import { getYearlyDiscountPercentage } from '@web/account/utils';
import { useNavigation } from '@web/navigation/NavigationProvider';

const ANNUAL_PLANS_RELEASE_DATE = new Date('2021-10-04');
const ONE_MINUTE = 1000 * 60;

export const useAnnualPlanAnnouncement = (currentUser, saveClientFlags) => {
  const { track } = useAnalytics();
  const { isVisible, open, close } = useModalState();
  const { navigate } = useNavigation();

  const shouldBeShown = !(
    !currentUser ||
    !currentUser.isAdmin ||
    new Date(currentUser.org.createdAt) >= ANNUAL_PLANS_RELEASE_DATE ||
    !currentUser.org.subscriptionStartDate ||
    currentUser.org.subscriptionCancelDate ||
    currentUser.org.isYearlyPlan ||
    currentUser.settings.clientFlags.annualPlanAnnouncementShown ||
    currentUser.org.subscriptionLevel === SUBSCRIPTION_LEVELS.OLD_PREMIUM
  );

  if (shouldBeShown && !isVisible) {
    setTimeout(open, ONE_MINUTE);
  }

  const dismiss = () => {
    saveClientFlags({ annualPlanAnnouncementShown: getNowDate().toISOString() });
    close();
  };

  const onButtonClick = () => {
    close();
    navigate('account.overview.billing');
    track(AnalyticsEvents.annualBillingAnnouncementUpdateClicked);
    saveClientFlags({ annualPlanAnnouncementShown: getNowDate().toISOString() });
  };

  const isYearlyPlanDiscounted = Boolean(
    currentUser &&
      getYearlyDiscountPercentage(currentUser.org.subscriptionLevel, currentUser.orgSettings)
  );

  return {
    shouldBeShown,
    onButtonClick,
    dismiss,
    isVisible,
    close,
    isYearlyPlanDiscounted,
  };
};
